// extracted by css-extract-rspack-plugin
export default {"root":"XBQ421","title":"GqqbPw","input-wrapper":"XxKkdq","inputWrapper":"XxKkdq","input-field":"niKXnK","inputField":"niKXnK","input":"Y9Z4l7"};